import { entityType } from 'config/entityType';
import { deleteFiles } from 'library/firebase/fb.auth.utils';
import SuperFetch from 'library/helpers/superFetch';
import { all, call, put, takeEvery } from 'redux-saga/effects';
import { floorsActions } from 'reduxStore/floors/slice';
import { Notification } from 'zComponents/atoms';
import { mapActions } from './slice';

function* handleCreateMap(action) {
	const { mapBody, entityName, oldData, uploadType } = action.payload;
	try {
		// 1) create the map
		const res = yield call(SuperFetch.post, '/maps/', mapBody);
		if (res && res.statusCode === 200 && res.data) {
			const mapID = res.data[0].ID;

			// 2) update the entity with the new map ID / filepath
			if (mapID) {
				// const patchBody = { name: entityID.toString() };
				// const patchRes = yield call(SuperFetch.patch, `/floors/${entityID}`, patchBody);

				// if (patchRes && patchRes.statusCode === 200) {
				if (entityName === 'Floor') yield put(floorsActions.loadFloors());

				yield put(mapActions.createMapSuccess({ map: res.data[0] }));
				Notification('success', 'Floor Plan Updated Successfully.');

				if (oldData) {
					yield call(cleanUpOldData, oldData, uploadType);
				}
				return;
				// }
			}

			// if patch failed
			Notification('error', 'Something went wrong! Please try again later.');
			yield put(mapActions.createMapError());
		} else {
			// post failed
			Notification('error', 'Error while uploading Floor Plan! Please try again.');
			yield put(mapActions.createMapError());
		}
	} catch (err) {
		Notification('error', 'Error while uploading Floor Plan! Please try again.');
		yield put(mapActions.createMapError(err));
	}
}

export function* watchCreateMap() {
	yield takeEvery(mapActions.createMap.type, handleCreateMap);
}

function* handleUpdateMap(action) {
	const { mapBody, entityName, oldData, uploadType } = action.payload;

	try {
		// PATCH request using your preferred pattern
		const res = yield call(() => SuperFetch.patch(`/maps/${oldData.mapID}`, mapBody));

		if (res && res.statusCode === 200) {
			if (entityName === 'Floor') {
				yield put(floorsActions.loadFloors());
			}

			yield put(mapActions.updateMapSuccess());

			if (oldData?.url) {
				yield call(cleanUpOldData, oldData, uploadType);
			}
		} else {
			yield put(mapActions.updateMapError());
		}
	} catch (err) {
		yield put(mapActions.updateMapError(err));
	}
}

export function* watchUpdateMap() {
	yield takeEvery(mapActions.updateMap.type, handleUpdateMap);
}

export default function* mapSaga() {
	yield all([watchCreateMap(), watchUpdateMap()]);
}

const cleanUpOldData = async (data, type) => {
	// Delete indoor maps reference in Zezamii DB
	if (data.mapID && data.url && type === 'indoorMap') {
		await SuperFetch.delete(`/maps/${data.mapID}`).then((res) => {
			if (res && res.statusCode === 200) {
				Notification('success', 'Old map and Device file deleted successfully');
			}
		});
		await deleteFiles(data.url);
	} else if (data.photoUrl && type === 'profilePicture') {
		if (!data.photoUrl.includes('/People/dummy')) {
			await deleteFiles(data.photoUrl);
		}
	}
};

//

// 👇 Functions to update maps
export function* updateMapSaga(mapID, mapData) {
	try {
		delete mapData.entityID;
		delete mapData.entityTypeID;

		const response = yield call(() => SuperFetch.patch(`/maps/${mapID}`, mapData));
		if (response.statusCode === 200) {
			Notification('success', 'Map updated successfully.');
		} else {
			throw Error('Failed to update map.');
		}
	} catch (error) {
		Notification('error', error.message || 'Map update failed.');
		throw error;
	}
}

// 👇 Function to create maps
export async function createMapSaga(mapData) {
	const { dimensionX, dimensionY, entityID, entityTypeID, name, url } = mapData;

	try {
		const response = await SuperFetch.post(`/maps`, {
			dimensionX,
			dimensionY,
			entityID,
			entityTypeID,
			name,
			url
		});

		if (response.statusCode === 200) {
			const mapID = response.data[0]?.mapID;

			if (entityType.SITE === entityTypeID) {
				await SuperFetch.patch(`/sites/${entityID}`, { mapID });
			} else if (entityType.FLOOR === entityTypeID) {
				await SuperFetch.patch(`/floors/${entityID}`, { mapID });
			}

			Notification('success', 'Map created successfully.');
		} else {
			throw new Error('Failed to create map.');
		}
	} catch (error) {
		Notification('error', error.message || 'Map creation failed.');
		throw error;
	}
}
